import { ReactElement } from "react";

interface ReportFileChipProps {
  name: string;
  size: number;
  /** Omitted when the workbook could not be parsed for preview. */
  rows?: number;
  columns?: number;
  disabled?: boolean;
  onRemove: () => void;
}

const formatSize = (bytes: number): string =>
  bytes < 1024 * 1024
    ? `${Math.max(1, Math.round(bytes / 1024))} KB`
    : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

/** The selected workbook, with what parsing found in it. */
const ReportFileChip: React.FC<ReportFileChipProps> = ({
  name,
  size,
  rows,
  columns,
  disabled = false,
  onRemove,
}): ReactElement => (
  <div className="file-chip">
    <div className="meta">
      <span className="badge">XLSX</span>
      <div>
        <p className="name" title={name}>
          {name}
        </p>
        <p className="sub">
          {formatSize(size)}
          {rows !== undefined && columns !== undefined
            ? ` · ${rows.toLocaleString("en-US")} rows · ${columns} columns`
            : ""}
        </p>
      </div>
    </div>
    <button
      type="button"
      className="remove"
      disabled={disabled}
      onClick={onRemove}
    >
      Remove
    </button>
  </div>
);

export default ReportFileChip;
